<template>
  <div class="page-content">
    <div class="exhibit-header">
      <img class="banner" src="../assets/images/perform.png" alt="">
      <div class="header-title w">
        <span class="yh1">举办大型展览展销活动“—件事”</span>
         <span  class="yh2">在本市举办以营利为目的，单场次参加人数1000人以上，租用、借用或者以其他形式临时占用场所、场地的展览展销活动。</span>
      </div>
    </div>
    <div class="list" style="margin:70px auto;">
      <ul>
        <li><a href="../../dxzlzxhd.pdf" target="_blank"><span>办事指南</span></a></li>
        <i></i>
        <li>
          <a href="../dxzlzx"><span>“一件事”解读</span></a>
          <div class="sj"></div>
        </li>
        <i></i>
        <li><a href="../hdsblv/home" target="_blank"><span>立即办理</span></a></li>
        <i></i>
        <li><a href="../denglv" target="_blank"><span>进度查询</span></a></li>
      </ul>
    </div>
    <div class="zcjd" style="width:100%;">
      <div class="title">办理事项</div>
      <div class="blsx-box">
        <div class="blsx-title"><span>举办大型展览展销活动一件事集成服务</span></div>
        <div class="blsx-inner">

          <div>
            <span>举办涉外营业性艺术品展览</span>
            <ul>
              <li>举办涉外商业性美术品/艺术品展览活动申请</li>
              <li>海关展览会备案</li>
              <li>跨省、自治区、直辖市举办大型群众性活动安全许可</li>
              <li>临时性商业户外广告设施设置方案上传公开</li>
            </ul>
          </div>

          <div>
            <span>举办涉外经济技术展览</span>
            <ul>
              <li>境内举办涉外经济技术展览会备案</li>
              <li>海关展览会备案</li>
              <li>食品展销会展前报告</li>
              <li>跨省、自治区、直辖市举办大型群众性活动安全许可</li>
              <li>临时性商业户外广告设施设置方案上传公开</li>
            </ul>
          </div>
          <div>
            <span>举办文物进境展览</span>
            <ul>
              <li>文物进境展览备案办理</li>
              <li>海关展览会备案</li>
              <li>跨省、自治区、直辖市举办大型群众性活动安全许可</li>
              <li>临时性商业户外广告设施设置方案上传公开</li>
            </ul>
          </div>

        </div>
      </div>
      <div class="title">办理时限</div>
      <img src="../assets/images/perform-blsx.png" alt="">
      <div class="title">办理流程</div>
      <div class="bllc-box">
        <div class="img-box">
          <img src="../assets/images/1.png" alt="">
          <img class="jd" src="../assets/images/jd.png" alt="">
          <img src="../assets/images/2.png" alt="">
          <img class="jd" src="../assets/images/jd.png" alt="">
          <img src="../assets/images/3.png" alt="">
          <img class="jd" src="../assets/images/jd.png" alt="">
          <img src="../assets/images/4.png" alt="">
          <img class="jd" src="../assets/images/jd.png" alt="">
          <a href="https://banshi.beijing.gov.cn/pubtask/dxhd/performjd.html#"><img src="../assets/images/5.png" alt=""></a>
        </div>
        <span>点击“立即办理”</span>
        <span>阅读“举办大型展览展销活动<br>一件事集成服务”用户须知</span>
        <span>填报申请信息</span>
        <span>完成线上申请</span>
        <a href="../denglv" target="_blank">
          <span>查询办件进度及办理结果<br><font style="color:#bd1a2d;">点击进入</font>
          </span>
        </a>
      </div>
      <div class="title">常见问题</div>
      <div class="cjwt-box">
        <ul>
          <li>
            <span class="sp1">构成大型展览展销活动的标准是什么？</span>
            <span class="sp2">答：法人或其他组织，租用、借用或者以其他形式临时占用场所、场地，向社会公众举办的，单场次参加人数一千人以上的展览展销活动。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              法人或其他组织，租用、借用或者以其他形式临时占用场所、场地，向社会公众举办的，单场次参加人数一千人以上的展览展销活动。
            </div>
          </li>
          <li>
            <span class="sp1">食品展销会的举办者应当履行哪些食品安全管理义务？</span>
            <span class="sp2">答：依法审查入场食品经营者的许可证等主体资质，明确其食品安全管理责任，定期对其经营环境和条件进行检查，发现其有违反食品安全法律法规规定行为的，应当及时制止，并立即报告属地市场监督管理部门。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              依法审查入场食品经营者的许可证等主体资质，明确其食品安全管理责任，定期对其经营环境和条件进行检查，发现其有违反食品安全法律法规规定行为的，应当及时制止，并立即报告属地市场监督管理部门。
            </div>
          </li>
          <li>
            <span class="sp1">什么情况可申请设置临时性商业户外广告设施？</span>
            <span class="sp2">答：主要是政府机关批准举办的，具有一定影响力和社会关注度的重大文化、体育、商业活动可按照需要申请设置临时性商业户外广告设施。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              主要是政府机关批准举办的，具有一定影响力和社会关注度的重大文化、体育、商业活动可按照需要申请设置临时性商业户外广告设施。
            </div>
          </li>
          <li class="_hidden yc" v-if="!isMoreVisible">
            <span class="sp1">申请举办涉外经济技术展览会的备案有什么要求吗？</span>
            <span class="sp2">答：首次举办冠名“中国”、“中华”、“全国”、“国家”等字样的、外国机构参与主办的涉外经济技术展览会，由商务部审批。市商务局负责其他涉外经济技术展览会的备案工作。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              首次举办冠名“中国”、“中华”、“全国”、“国家”等字样的、外国机构参与主办的涉外经济技术展览会，由商务部审批。市商务局负责其他涉外经济技术展览会的备案工作。
            </div>
          </li>
          <li class="_hidden yc" v-if="!isMoreVisible">
            <span class="sp1">举办大型展览展销活动需要提前多久进行申请？</span>
            <span class="sp2">答：1.举办涉外经济技术展，展览会备案填报单位应于展会举办前至少三个月办理展会备案。
							2.举办涉外营业性艺术品展览，应当由主办或承办单位于展览日四十五日前，提出申请。
							3.举办文物进境展览，承办者应当在举办大型文物进境展览活动的二十个工作日前申请安全许可。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              1.举办涉外经济技术展，展览会备案填报单位应于展会举办前至少三个月办理展会备案。<br>
              2.举办涉外营业性艺术品展览，应当由主办或承办单位于展览日四十五日前，提出申请。<br>
              3.举办文物进境展览，承办者应当在举办大型文物进境展览活动的二十个工作日前申请安全许可。
            </div>
          </li>
          <li class="_hidden yc" v-if="!isMoreVisible">
            <span class="sp1">设置临时性商业户外广告设施有哪些要求？</span>
            <span class="sp2">答：1、不得设置在《北京市户外广告设施设置专项规划（2022年-2035年）》和所在街区户外广告设施设置规划划定的商业户外广告设施禁止设置区域内。
							2、不得存在《北京市户外广告设施、牌匾标识和标语宣传品设置管理条例》和《北京市户外广告设施设置专项规划（2022年-2035年）》规定的禁止设置情形。
							3、设置临时性商业户外广告设施不得超出商业活动举办场所；没有活动举办场所的，不得设置。
							4、临时性商业户外广告设施设置期限不宜超过15天，在相同位置针对不同活动设置临时性商业户外广告设施天数，一年内累计不超过100天，商业步行街不宜超过180天；设置时间不早于活动开始前2天，于活动结束后2天内撤除。
							5、设置的临时性商业户外广告设施应当安全牢固，符合节能环保要求，与所处街区环境尺度及景观风貌相协调，不得危及人身安全，不得影响建（构）筑物安全和功能，不得妨碍相邻建筑物、构筑物的通风、采光，不得妨碍交通和消防安全。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              1、不得设置在《北京市户外广告设施设置专项规划（2022年-2035年）》和所在街区户外广告设施设置规划划定的商业户外广告设施禁止设置区域内。<br>
              2、不得存在《北京市户外广告设施、牌匾标识和标语宣传品设置管理条例》和《北京市户外广告设施设置专项规划（2022年-2035年）》规定的禁止设置情形。<br>
              3、设置临时性商业户外广告设施不得超出商业活动举办场所；没有活动举办场所的，不得设置。<br>
              4、临时性商业户外广告设施设置期限不宜超过15天，在相同位置针对不同活动设置临时性商业户外广告设施天数，一年内累计不超过100天，商业步行街不宜超过180天；设置时间不早于活动开始前2天，于活动结束后2天内撤除。<br>
              5、设置的临时性商业户外广告设施应当安全牢固，符合节能环保要求，与所处街区环境尺度及景观风貌相协调，不得危及人身安全，不得影响建（构）筑物安全和功能，不得妨碍相邻建筑物、构筑物的通风、采光，不得妨碍交通和消防安全。
            </div>
          </li>
          <li class="_hidden yc" v-if="!isMoreVisible">
            <span class="sp1">艺术品的类别有哪些？</span>
            <span class="sp2">答：包括绘画作品、书法作品、雕塑作品、摄影作品、装置艺术作品。不属于《艺术品经营管理办法》管理范畴的艺术产品类别是：根据图样订单批量手工制作，手工制作者不享有原创著作权的手工制品，如根据订单图样要求，手工批量会之德装饰画、陈设用品、礼品、日常用品等。</span>
            <div class="pop-up">
              <div class="jiao"></div>
              包括绘画作品、书法作品、雕塑作品、摄影作品、装置艺术作品。不属于《艺术品经营管理办法》管理范畴的艺术产品类别是：根据图样订单批量手工制作，手工制作者不享有原创著作权的手工制品，如根据订单图样要求，手工批量会之德装饰画、陈设用品、礼品、日常用品等。
            </div>
          </li>
        </ul>
        <div>
          <div class="clear"></div>
          <a id="more"
              href="javascript: ;"
              @click="showMore"
              v-if="isMoreVisible"
          >
            查看更多&gt;
          </a>
          <a
              id="sq"
              class="_hidden"
              href="javascript: ;"
              @click="hideMore"
              v-if="!isMoreVisible"
          >
            收起
          </a>
          </div>
      </div>
      <div class="title">相关政策</div>
      <div class="page" style="margin-bottom:10px;">
        <div id="page">
          <a class="last_page sy" href="javascript:void(0);"  @click="prevPage"> </a>
          <a class="last_page xy" href="javascript:void(0);" @click="nextPage"> </a></div>
      </div>
      <div class="xgzc-box">
        <ul id="all">
          <li v-for="item in pagedList" :key="item.url">
            <a :href="item.url" target="_blank">
              {{ item.title }}<span>详情 &gt;</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DxzlzxJdHome",
  data() {
    return {
      // 控制"查看更多"和"收起"的显示状态
      isMoreVisible: true,
      // 控制显示隐藏内容的状态
      isVisible: false,
      pageSize: 5,       // 每页 5 条
      currentPage: 1,
      list: [
        {
          title: '《艺术品经营管理办法》',
          url: 'https://www.beijing.gov.cn/zhengce/zhengcefagui/qtwj/201601/t20160118_781381.html'
        },
        {
          title: '《国务院对确需保留的行政审批项目设定行政许可的决定》',
          url: 'https://www.beijing.gov.cn/zhengce/zhengcefagui/202208/t20220808_2788334.html'
        },
        {
          title: '《国务院关于取消和下放一批行政审批项目的决定》',
          url: 'https://www.beijing.gov.cn/zhengce/zhengcefagui/qtwj/201402/t20140215_781023.html'
        },
        {
          title: '《中华人民共和国海关暂时进出境货物管理办法》',
          url: 'https://www.beijing.gov.cn/zhengce/zhengcefagui/201905/t20190522_60612.html'
        },
        {
          title: '《大型群众性活动安全管理条例》',
          url: 'https://www.beijing.gov.cn/zhengce/zhengcefagui/qtwj/201105/t20110506_780999.html'
        },
        {
          title: '《北京市大型群众性活动安全管理条例》',
          url: 'https://www.beijing.gov.cn/zhengce/dfxfg/201905/t20190522_59874.html'
        },
        {
          title: '《北京市户外广告设施、牌匾标识和标语宣传品设置管理条例》',
          url: 'https://www.beijing.gov.cn/zhengce/dfxfg/202106/t20210623_2419046.html'
        }
      ]
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.list.length / this.pageSize)
    },
    pagedList () {
      const start = (this.currentPage - 1) * this.pageSize
      return this.list.slice(start, start + this.pageSize)
    },
  },
  methods: {
    // 点击查看更多，显示内容并隐藏查看更多按钮
    showMore() {
      this.isVisible = true;
      this.isMoreVisible = false;
    },
    // 点击收起，隐藏内容并显示查看更多按钮
    hideMore() {
      this.isVisible = false;
      this.isMoreVisible = true;
    },
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    }
  }
}
</script>

<style scoped>
.zcjd{
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}
.exhibit-header{width:100%;height:200px;position:relative;min-width:1200px;overflow: hidden;background-color: #0356ad;
  margin-top: 40px;
  margin-bottom: 40px;
}
.banner{min-width:400px;position:absolute;left:85%;top:0;height:200px;transform: translate(-50%,0);}
.header-title{bottom:0px;position:absolute;height:140px;z-index:999999999;
  box-sizing: border-box;}
.yh1{position:absolute;top:0px;left:30px;font-size:40px;}
.yh2{position:absolute;bottom:10px;left:30px;font-size:18px;}
.header-title span{display:block;color:#fff;width:800px;}
.list{margin-top:50px;float:left;}
.list ul{
  list-style: none;
}
.list li{width:200px;float:left;height:140px;font-size:24px;line-height:80px;box-sizing: border-box;margin-left:46px;position:relative;}
.list li a{display:block;color:#000;width: 100%;height: 100%;box-sizing: border-box;text-align:center;}
.list li a span{height:60px;display:block;line-height:200px;}
.sj{position:absolute;width:20px;height:20px;background-color: #0356ad;border-right:none;border-bottom:none;bottom:-11px;left:50%;transform:translate(-50%,0) rotate(45deg);z-index:9999999999999;}

.list li:hover{background-color: #0356ad;}
.list li:nth-child(3){background-color: #0356ad;}
.list li:nth-child(3) a{color:#fff}
.list li:hover a{color:#fff;}
.list i{display:block;height:75px;width:1px;background-color: #D8D8D8;float:left;margin:27px 0px 0px 50px;}
.list li:nth-child(1) a{text-decoration: none;background: url(../assets/images/bszn.png) no-repeat 80px 20px;}
.list li:nth-child(3) a{text-decoration: none;background: url(../assets/images/fwgl.png) no-repeat 80px 20px;}
.list li:nth-child(5) a{text-decoration: none;background: url(../assets/images/ljbl.png) no-repeat 80px 20px;}
.list li:nth-child(7) a{text-decoration: none;background: url(../assets/images/jdcx.png) no-repeat 80px 20px;}
.list li:nth-child(1) a:hover{text-decoration: none;background: url(../assets/images/bszn_b.png) no-repeat 80px 20px;}
.list li:nth-child(3) a{text-decoration: none;background: url(../assets/images/fwgl_b.png) no-repeat 80px 20px;}
.list li:nth-child(5) a:hover{text-decoration: none;background: url(../assets/images/ljbl_b.png) no-repeat 80px 20px;}
.list li:nth-child(7) a:hover{text-decoration: none;background: url(../assets/images/jdcx_b.png) no-repeat 80px 20px;}


.title{font-weight:700;float:left;margin:70px 0px 35px 0px;
  background:url(../assets/images/title.png) no-repeat 26px 0px;
  font-size:34px;width:100%;text-align:center;height:48px;line-height:36px;}
.blsx-title{overflow:hidden;width: 100%;height:53px;line-height:53px;background-color:#0356ad;float:left;color:#fff;padding:0px 30px;box-sizing: border-box;}
.blsx-title span{font-size:24px;}
.blsx-title i{font-size:38px;margin-right:10px;float:right;font-style:normal;}
.blsx-title font{float:right;font-size:20px;line-height:60px;}
.blsx-inner{float:left;border:1px solid #bd1a2d;box-sizing: border-box;}
.blsx-inner li{float:left;width:40%;padding:10px 0px 10px 50px;box-sizing:border-box;margin:10px 58px;font-size:18px;color:#333333;background:url(../assets/images/inner-b.png) no-repeat 0px 6px;}
.bllc-box{width: 100%;height: 190px;box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);float:left;font-size:16px;}
.img-box{margin:40px 0px 0px 100px;}
.img-box img{margin-right:2px;}
.jd{margin-bottom:15px;}
.bllc-box span{display:block;float:left;text-align:center;margin-left:10px;margin-top:30px;width:224px;}
.bllc-box a{color:#333333;}
.cjwt-box{float:left;width:100%;}
.cjwt-box ul{
  list-style: none;
  min-height:300px;}
.cjwt-box li{
  width:100%;height: 86px;box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
  background: url(../assets/images/ask.png) no-repeat 20px 10px;
  padding:15px 10px 0px 90px;box-sizing: border-box;position:relative;}
.cjwt-box li span{display:block;}
.sp1{color:#000000;font-weight:700;font-size:20px;}
.sp2{color:#9F9F9F;font-size:16px;margin-top:10px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
.pop-up{position:absolute;width:1000px;min-height:20px;border:1px solid #bd1a2d;background-color: #fff;padding:10px;left:20%;top:80px;box-sizing:border-box;z-index: 9999999999999;line-height:34px;font-size:14px;display:none;}
.pop-up div{position:absolute;width:20px;height:20px;border:1px solid #bd1a2d;background-color: #fff;border-right:none;border-bottom:none;transform:rotate(45deg);top:-11px;left:30%;z-index:9999999999999;}
.cjwt-box li:hover .pop-up{display:block;}
#more,#sq{
  text-decoration: none;
  font-size:18px;display:block;width:160px;height:40px;
  line-height:40px;margin:30px auto 0px;
  text-align:center;color:#fff;background-color: #bd1a2d;}
.xgzc-box{
  width:100%;box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
  float:left;padding:20px;box-sizing:border-box;
  margin-bottom:80px;min-height:298px;}
.xgzc-box ul{
  list-style: none;
}
.xgzc-box li{width:100%;float:left;height:50px;line-height: 50px;border-bottom:2px dashed rgba(192,192,192,1);}
.xgzc-box li:last-child{border:none;}
.xgzc-box li a{text-decoration: none;color:#333333;font-weight:700;font-size:18px;}
.xgzc-box li a span{text-decoration: none;float:right;color:#bd1a2d;}
#ljbl{display:none;position:fixed;bottom:300px;right:0;}
.blsx-inner div {width:30%;overflow:hidden;float:left;margin:28px 0px 0px 30px;}
.blsx-inner div span{width:100%;text-align:center;display:block;height:50px;line-height:25px;font-size:20px;border-bottom:2px dashed #BD1A2D;}
.blsx-inner div ul{padding:20px 0px 20px 0px;float:left;}
.blsx-inner div li{width:100%;margin:5px 0px 0px;font-size:14px;padding:10px 0px 0 15px;background: url(../assets/images/y_saojiao.png) no-repeat 0px 15px;}
.sy,.xy{width:33px;height:32px;display:block;float:left;}
.sy{background: url(../assets/images/sy_b.png) no-repeat;}
.xy{background: url(../assets/images/xy_b.png) no-repeat;}
.sy:hover{background: url(../assets/images/sy_h.png) no-repeat;}
.xy:hover{background: url(../assets/images/xy_h.png) no-repeat;}
.page{
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
}

.gdfw-d{
  width:48%;
  float:left;
  box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
  position:relative;
  padding:60px 40px 40px 40px;
  box-sizing: border-box;
}
.gdfw-d-s{
  position:absolute;
  display:block;
  background-color: #bd1a2d;
  color:#fff;
  font-size:18px;
  height:38px;
  line-height:38px;
  width:45%;
  text-align:center;
  top:-18px;
  left:50%;
  transform:translate(-50%,0);
}
.gdfw-d-ul li{
  float:left;
  width:100%;
  height:40px;
  position:relative;
}
.gdfw-d-ul li span{
  float:left;
  font-weight:700;
  font-size:16px;
}
.gdfw-d-ul li a,.tanchua {
  float:right;
  color:#bd1a2d;
  font-size:16px;
  text-decoration:solid !important;
  font-weight:700;
}
.tanchu{
  width:400px;
  border:1px solid #bd1a2d;
  position:absolute;
  background-color: #ffefeb;
  z-index:2;
  right: -167px;
  top: 30px;
  padding-top:20px;
  display:none;
}
.qyxzUl li{
  margin: 0px 0px 0px 6px;
  color: #000;
  float: left;
  cursor: pointer;
  width: 72px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.qyxzUl li a{
  color:#000;
  font-weight:700;
  width:100%;
}
.tanchu .jiao{
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #bd1a2d;
  background-color: #ffefeb;
  border-right: none;
  border-bottom: none;
  top: -4px;
  left: 50%;
  transform: rotate(45deg) translate(-50%,0);
  z-index: 9999999999999;
}
.tanchua {
  cursor:pointer;
  height:40px;
}
.tanchua:hover .tanchu{
  display:block;
}
</style>
